import React from 'react';

import Page from 'components/page';
import LandingSection from 'components/landingSection';
import ServicesSection from 'components/servicesSection';
import OurCommodities from 'components/ourCommodities';
import CoreValuesSection from 'components/coreValuesSection';
import MoreUpdatesSection from 'components/moreUpdatesSection';
import OurSolutions from 'components/ourSolutions';
import HomeTabs from 'components/homeTabs';
import ScrollButtons from 'components/scrollButtons';

const HomePage = ({ location: { hash } }) => {
  const scrollableSections = [
    'landingSection',
    'ourSolutions',
    'ourCommodities',
    'ourServices',
    'coreValues',
  ];
  return (
    <Page pageName="home">
      <ScrollButtons sections={scrollableSections} />
      <LandingSection />
      <OurSolutions />
      <OurCommodities />
      <ServicesSection />
      <CoreValuesSection />
      <MoreUpdatesSection />
      <HomeTabs defaultTab={hash.replace(/#/g, '')} />
    </Page>
  );
};

export default HomePage;
